export const queryKeys = {
  COMPOSERS: "get-composers",
};
